export const BaseUrl="https://contolioapiprod.azurewebsites.net/"



export const apiVersion="api/v1/"
export const GoogleKey="AIzaSyAleyL-3hoA9aO0eTcLvwgBGeJcDWIRa0w"
export const exportUrl="https://contolioapiprod.azurewebsites.net/excel_export/"

